import { Model as m } from "../../../../../model.js";
class e extends m {
  constructor(i) {
    super(), this.maximumBalance = i.maximumBalance, this.maximumAccumulatedBalance = i.maximumAccumulatedBalance, this.initialBalance = i.initialBalance, this.cycle = i.cycle;
  }
  isUnlimited() {
    return this.maximumBalance === 1 / 0 || this.cycle.infinite;
  }
}
export {
  e as StampProgrammeSettingsBalanceModel
};
//# sourceMappingURL=stampProgrammeSettingsBalance.model.js.map
